export default "__VITE_ASSET__f7e8e71d__"